import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { messaging } from './firebaseConfig'; // 🔥 novo import para FCM
import { onMessage } from 'firebase/messaging'; // 🔥 novo import para escutar mensagens

serviceWorkerRegistration.register(); // Ativa o PWA

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// 🔥 Escutar notificações recebidas enquanto app está aberto
onMessage(messaging, (payload) => {
  console.log('🔔 Notificação recebida no app aberto:', payload);
  // Aqui você pode personalizar, ex: mostrar alerta ou popup se quiser
  // alert(`Nova notificação: ${payload.notification.title} - ${payload.notification.body}`);
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
